// src/components/LoginModal.js
import React, { useState, useContext } from 'react';
import Modal from 'react-modal';
import { AuthContext } from '../context/AuthContext';
import "./css/LoginModal.css"


const LoginModal = ({ isOpen, onRequestClose, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login({
        username,
        password
      })
      setUsername('')
      setPassword('')
      onLoginSuccess();
    } catch (errorMessage) {
      setPassword('')
      console.log("error logging in", errorMessage);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Login Modal"
      className="login-modal-content"
      overlayClassName="login-modal-overlay"
    >
      <div className="login-modal">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <label>
            Username:
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </label>
          <label>
            Password:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <button type="submit">Login</button>
        </form>
      </div>
    </Modal>
  );
};

export default LoginModal;
